// extracted by mini-css-extract-plugin
module.exports = {"button":"ContentTab_button__7AWlh","content":"ContentTab_content__n_U6E","onlyOne":"ContentTab_onlyOne__hZ_l_"};